import {Routes} from '@angular/router';
import {OperatorPanelRoutes} from './operator-panel-routes';
import {OpenTablesComponent} from '../open-tables/overview/open-tables.component';

/**
 * Child routes hosted under the Operator panel shell ({@link OperatorComponent}, #205). Currently a single
 * screen: the live open-tables overview from workstream C, reused verbatim — it is deliberately shell-agnostic
 * (`position: absolute; inset: 0`, no navigation of its own; see its own doc comment) so it serves both the
 * admin route (`LocationRoutes.BookingEntityOverview`) and this panel without a second implementation. A
 * kitchen screen ("Küche") is the documented next entry — see {@link OperatorPanelRoutes}.
 */
export const OPERATORPANEL_ROUTES: Routes = [
  {path: OperatorPanelRoutes.OpenTables, component: OpenTablesComponent, title: 'Offene Tische'},
  {path: '**', redirectTo: '' + OperatorPanelRoutes.OpenTables, pathMatch: 'full'},
];
